var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7122_9209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1539 20.8722C17.8792 19.9582 21.7795 14.576 20.8656 8.85074C19.9516 3.12544 14.5694 -0.774912 8.8441 0.139058C3.1188 1.05303 -0.781542 6.43522 0.132428 12.1605C1.0464 17.8858 6.42858 21.7862 12.1539 20.8722Z",
    fill: "#045694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09704 8.54447H8.12805V15.0801H6.09704V8.54447ZM7.11255 5.29835C7.34619 5.29835 7.57458 5.36769 7.76879 5.49759C7.963 5.62749 8.1143 5.8121 8.20351 6.02804C8.29272 6.24399 8.31585 6.48155 8.26995 6.71064C8.22405 6.93974 8.11119 7.15006 7.94567 7.31497C7.78015 7.47988 7.56942 7.59196 7.34016 7.63701C7.1109 7.68207 6.87342 7.65807 6.65781 7.56806C6.44219 7.47805 6.25814 7.32608 6.12895 7.1314C5.99977 6.93671 5.93128 6.70806 5.93214 6.47442C5.93214 6.31961 5.96269 6.16632 6.02207 6.02335C6.08144 5.88038 6.16846 5.75054 6.27813 5.64127C6.3878 5.53201 6.51796 5.44547 6.66115 5.38662C6.80434 5.32778 6.95774 5.29778 7.11255 5.29835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40457 8.54537H11.3531V9.43936H11.3791C11.5743 9.10617 11.8561 8.83214 12.1947 8.64644C12.5332 8.46074 12.9158 8.37032 13.3017 8.3848C15.3587 8.3848 15.7363 9.7388 15.7363 11.4964V15.081H13.6879V11.9043C13.6879 11.1449 13.6879 10.1684 12.6333 10.1684C11.5788 10.1684 11.4182 10.993 11.4182 11.8436V15.0767H9.38721L9.40457 8.54537Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7122_9209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhLinkedin);
export default __webpack_public_path__ + "static/media/fmh-linkedin.2e891b29c8543435679dcd08346559e3.svg";
export { ForwardRef as ReactComponent };